export enum HighlightBlockContentType {
  AUTOMATIC = 'automatic',
  AUTOMATIC_IN_PROGRESS = 'automatic_in_progress',
  MANUAL = 'manual',
  MANUAL_SELECTION = 'manual_selection'
}
